'use strict';
angular.module('cvsApp').filter('unsafe', ['$sce', function ($sce) {
    return function (val) {
    	if(typeof(val) == 'object'){
    		if(val.__text != undefined){
    			return $sce.trustAsHtml((val.__text).replace(/[\n\t\r]+/g,''));
    		}
    	}
    	else {
            val = val ? val.split('&lt;').join('<').split('&gt;').join('>') : val;
        }
        return $sce.trustAsHtml(val);
    };
}]);

angular.module('cvsApp').filter('clean', function () {
    return function (text) {
    	if(typeof(text) == 'object'){
    		if(text.__text != undefined){
    			return (text.__text).replace(/[\n\t\r]+/g,'');
    		}
    	}
        return text;
    };
});

/* Custom curruncy filter for display negative values with minus sing. */
angular.module('cvsApp').filter('customCurrency', ["$filter", function ($filter) {
    return function(amount, currencySymbol){
        var currency = $filter('currency');
        if (amount == '') {
        	return '';
        }
        if(amount < 0){
            return currency(amount, currencySymbol).replace('(', '-').replace(')', '');
        }
		return currency(amount, currencySymbol);
    };
}]);

angular.module('cvsApp').filter('tel', function () {
    return function (tel) {
        if (!tel) { return ''; }


        var value = tel.toString().trim().replace(/^\+/, '');


        if (value.match(/[^0-9]/)) {
            return tel;
        }


        var country, city, number;


        switch (value.length) {
            case 10: // +1PPP####### -> C (PPP) ###-####
                country = 1;
                city = value.slice(0, 3);
                number = value.slice(3);
                break;


            case 11: // +CPPP####### -> CCC (PP) ###-####
                country = value[0];
                city = value.slice(1, 4);
                number = value.slice(4);
                break;


            case 12: // +CCCPP####### -> CCC (PP) ###-####
                country = value.slice(0, 3);
                city = value.slice(3, 5);
                number = value.slice(5);
                break;


            default:
                return tel;
        }


        if (country == 1) {
            country = "";
        }


        number = number.slice(0, 3) + '-' + number.slice(3);

        return (country + " " + city + "-" + number).trim();
    };

});

angular.module('cvsApp').filter('telmyaccount', function () {
    return function (tel) {
        if (!tel) { return ''; }

        var value = tel.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return tel;
        }

        var country, city, number;

        switch (value.length) {
            case 10: // +1PPP####### -> C (PPP) ###-####
                country = 1;
                city = value.slice(0, 3);
                number = value.slice(3);
                break;

            case 11: // +CPPP####### -> CCC (PP) ###-####
                country = value[0];
                city = value.slice(1, 4);
                number = value.slice(4);
                break;

            case 12: // +CCCPP####### -> CCC (PP) ###-####
                country = value.slice(0, 3);
                city = value.slice(3, 5);
                number = value.slice(5);
                break;

            default:
                return tel;
        }

        if (country == 1) {
            country = "";
        }

        number = number.slice(0, 3) + '-' + number.slice(3);

        return (country + " (" + city + ") " + number).trim();
    };
});

angular.module('cvsApp').filter('limitRange', function() {
    return function(items, begin, end) {
        if(items){
            return items.slice( begin, end);
        }else{
            return items;
        }

    }
});

angular.module('cvsApp').filter('payHistoryCurrency', ["$filter", function ($filter) {
    return function(amount, currencySymbol){
        var currency = $filter('currency');
        if (amount  && amount > 0) {
            return currency("+"+amount, currencySymbol).replace('$', '+$');
        }
        return currency(amount, currencySymbol);
    };
}]);
/* Custom filter to display title in title case */
angular.module('cvsApp').filter('titleCase', function() {
    return function(input) {
      input = input || '';
      return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    };
  })